import { Component, OnInit, Output, EventEmitter, Input, AfterViewInit } from '@angular/core';
import { JsonEditorField } from '../../_models/JsonEditorField';

@Component({
    selector: 'app-core-engine-field',
    templateUrl: './core-engine-field.component.html',
    styleUrls: ['./core-engine-field.component.css'],
  })

  export class CoreEngineFieldComponent implements OnInit {
    public listOfTypes = [
        'Array',
        'Object',
        'String',
        'Number',
        'Boolean',
        'Null'
      ];
    public key;
    public value;
    public type = 'String';
    public pairValue: JsonEditorField;

    @Input()
    showPreview: boolean;

    @Input()
    public set initialPairValue (value: JsonEditorField) {

      if (value) {

        this.pairValue = value;
        this.ngOnInit();
      }
    };

    @Input()
    editMode: boolean;
    @Output()
    pair = new EventEmitter();
    @Output()
    delete = new EventEmitter();

    constructor() {
    }

    handleBoolean() {
      this.value = !this.value;
      this.pair.emit(JSON.stringify({key: this.key, value: this.value, type: this.type}));
    }

    ngOnInit(): void {

      if (this.pairValue) {

        this.key = this.pairValue.key;
        this.value = this.pairValue.value;
        this.type = this.pairValue.type;
      }
    }

    clearValue() {
      this.value = '';
      this.pair.emit(JSON.stringify({key: this.key, value: this.value, type: this.type}));
    }

    addKey() {
        this.pair.emit(JSON.stringify({key: this.key, value: this.value, type: this.type}));
    }

    deleteItem() {
      this.delete.emit();
    }
  }
